// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCv-zTm5_9XMaKfYX5iPRCg0_21Ck7e_Ts",
  authDomain: "draftchallenge.firebaseapp.com",
  projectId: "draftchallenge",
  storageBucket: "draftchallenge.firebasestorage.app",
  messagingSenderId: "170840714512",
  appId: "1:170840714512:web:af94eb5a9b6ff042564995",
  measurementId: "G-0FVXW77L3H"
}; 

export const app = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApp();


export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);


